/** AUTH57 offline private snapshot — IndexedDB application store (not Cache API / SW). */

export const OFFLINE_DB_NAME = 'travel_offline_v1';
export const OFFLINE_STORE_NAME = 'snapshots';
export const OFFLINE_CACHE_SCHEMA_VERSION = 1;

export const OFFLINE_SNAPSHOT_TYPES = Object.freeze({
  OVERVIEW: 'OVERVIEW',
  TODAY: 'TODAY',
});

/** Routes that may eventually render under offline_cached (Slice B). Slice A unlocks shell only. */
export const OFFLINE_CACHED_ROUTE_PATTERNS = Object.freeze([
  /^\/journeys\/[1-9]\d*$/,
  /^\/journeys\/[1-9]\d*\/today$/,
]);

export function normalizeOfflineMemberId(memberId) {
  if (memberId == null || memberId === '') return null;
  const text = String(memberId).trim();
  return text || null;
}

export function buildOfflineSnapshotKey(memberId, journeyId, snapshotType) {
  const mid = normalizeOfflineMemberId(memberId);
  const jid = journeyId == null ? '' : String(journeyId).trim();
  const type = String(snapshotType || '');
  if (!mid || !jid || !type) {
    throw new Error('offline snapshot key requires memberId, journeyId, and snapshotType');
  }
  return `${mid}::${jid}::${type}`;
}

export function isOfflineCachedAllowedPath(pathname) {
  const path = String(pathname || '');
  return OFFLINE_CACHED_ROUTE_PATTERNS.some((pattern) => pattern.test(path));
}
